import { environment } from '~env/environment';

export const HEADER_KEY_MM_ACCOUNT_ID = 'X-ID-MM';
export const HEADER_KEY_GA_CLIENT_ID = 'X-ID-GA';
export const HEADER_KEY_OPTIMIZELY_USER_ID = 'X-ID-OM';
export const HEADER_KEY_EXPONEA_COOKIE = 'X-ID-CO';

export const SEARCH_API_CUSTOM_HEADER_URLS = () => [
  environment.svcSearch2BaseUrl()
];
